import { render, staticRenderFns } from "./CartSectionProductBatchDetail.vue?vue&type=template&id=e97e993e&scoped=true"
import script from "./CartSectionProductBatchDetail.vue?vue&type=script&lang=js"
export * from "./CartSectionProductBatchDetail.vue?vue&type=script&lang=js"
import style0 from "./CartSectionProductBatchDetail.vue?vue&type=style&index=0&id=e97e993e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97e993e",
  null
  
)

export default component.exports